import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, Observable, of, switchMap } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { Action } from '@ngrx/store';
import {
  LoginCodeInterface,
  ResponseLoginInterface,
} from '../../interfaces/auth.interface';
import { loginCode, requestSuccess, requestError } from './actions';
import { ErrorInterface } from '../../interfaces/general.interface';

import { CookieCustomService } from '../../services/cookie.custom.service';

@Injectable()
export class LoginCodeEffect {
  constructor(
    private router: Router,
    private service: AuthService,
    private actions$: Actions,
    private cookieService: CookieCustomService
  ) {}

  public loginCode$ = createEffect((): Observable<Action> => {
    return this.actions$.pipe(
      ofType(loginCode),
      switchMap((payload: { params: LoginCodeInterface }) =>
        this.service.checkLoginCode(payload.params).pipe(
          map((response: ResponseLoginInterface) => {
            if (response.errorCode.code !== 0) {
              if (response.details && typeof response.details === 'string') {
                response.errorCode.details = response.details;
              }
              throw response.errorCode;
            }
            this.cookieService.updateAuthCookie(response);
            return requestSuccess({ response: response.response });
          }),
          catchError((error: ErrorInterface) => of(requestError({ error })))
        )
      )
    );
  });
}
